import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonFormattingModule, CommonTranslationModule } from '@sdbn/common';
import { TransportListComponent } from './component/transport-list.component';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { TransportColumnFormatPipe } from './column-format.pipe';



@NgModule({
  declarations: [
    TransportListComponent,
    TransportColumnFormatPipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    CommonFormattingModule
  ],
  exports: [
    TransportListComponent
  ]
})
export class TransportListModule { }
